import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  PURCHASE_ORDERS_INDEX_REQUESTED,
  PURCHASE_ORDERS_INDEX_SUCCESS,
  PURCHASE_ORDERS_INDEX_FAILURE,
  PURCHASE_ORDER_FIND_REQUESTED,
  PURCHASE_ORDER_FIND_SUCCESS,
  PURCHASE_ORDER_FIND_FAILURE,
  PURCHASE_ORDERS_CREATE_REQUESTED,
  PURCHASE_ORDERS_CREATE_SUCCESS,
  PURCHASE_ORDERS_CREATE_FAILURE,
  PURCHASE_ORDERS_UPDATE_REQUESTED,
  PURCHASE_ORDERS_UPDATE_SUCCESS,
  PURCHASE_ORDERS_UPDATE_FAILURE,
  ADD_TO_PO,
  UPDATE_EXTERNAL_PO_LINE,
  REMOVE_FROM_PO,
  OVERRIDE_UNIT_COST,
  UPDATE_PO_QUANTITY,
  OVERRIDE_UNIT_TAX,
  ADJUST_TOTAL,
  PURCHASE_ORDER_MARK_PAID_REQUESTED,
  PURCHASE_ORDER_MARK_PAID_SUCCESS,
  PURCHASE_ORDER_MARK_PAID_FAILURE,
  PURCHASE_ORDER_MARK_CLOSED_REQUESTED,
  PURCHASE_ORDER_MARK_CLOSED_SUCCESS,
  PURCHASE_ORDER_MARK_CLOSED_FAILURE,
  PURCHASE_ORDER_MARK_ISSUED_REQUESTED,
  PURCHASE_ORDER_MARK_ISSUED_SUCCESS,
  PURCHASE_ORDER_MARK_ISSUED_FAILURE,
  PURCHASE_ORDER_MARK_FULFILLED_REQUESTED,
  PURCHASE_ORDER_MARK_FULFILLED_SUCCESS,
  PURCHASE_ORDER_MARK_FULFILLED_FAILURE,
  PURCHASE_ORDER_MARK_REJECTED_REQUESTED,
  PURCHASE_ORDER_MARK_REJECTED_SUCCESS,
  PURCHASE_ORDER_MARK_REJECTED_FAILURE,
  PURCHASE_ORDER_DOWNLOAD_REQUESTED,
  PURCHASE_ORDER_DOWNLOAD_SUCCESS,
  PURCHASE_ORDER_DOWNLOAD_FAILURE,
  PURCHASE_ORDER_UPDATE_SHIPMENTS_REQUESTED,
  PURCHASE_ORDER_UPDATE_SHIPMENTS_SUCCESS,
  PURCHASE_ORDER_UPDATE_SHIPMENTS_FAILURE,
  PURCHASE_ORDER_CHECK_ITEM_EXISTENCE_REQUESTED,
  PURCHASE_ORDER_CHECK_ITEM_EXISTENCE_SUCCESS,
  PURCHASE_ORDER_CHECK_ITEM_EXISTENCE_FAILURE,
  RESET_PURCHASE_ORDER_STATE,
  RESET_NEW_PO,
} from '../types';

export const purchaseOrdersIndexRequested = () => {
  return {
    type: PURCHASE_ORDERS_INDEX_REQUESTED
  }
};

export const purchaseOrdersIndexSuccess = (purchaseOrders, page) => {
  return {
    type: PURCHASE_ORDERS_INDEX_SUCCESS,
    payload: purchaseOrders,
    page: page
  }
};

export const purchaseOrdersIndexFailure = () => {
  return {
    type: PURCHASE_ORDERS_INDEX_FAILURE
  }
};


export const purchaseOrderFindRequested = () => {
  return {
    type: PURCHASE_ORDER_FIND_REQUESTED
  }
};

export const purchaseOrderFindSuccess = (purchaseOrder) => {
  return {
    type: PURCHASE_ORDER_FIND_SUCCESS,
    payload: purchaseOrder
  }
};

export const purchaseOrderFindFailure = () => {
  return {
    type: PURCHASE_ORDER_FIND_FAILURE
  }
};



export const purchaseOrdersCreateRequested = () => {
  return {
    type: PURCHASE_ORDERS_CREATE_REQUESTED
  }
};

export const purchaseOrdersCreateSuccess = (purchaseOrder) => {
  return {
    type: PURCHASE_ORDERS_CREATE_SUCCESS,
    purchaseOrder: purchaseOrder.new_purchase_order
  }
};

export const purchaseOrdersCreateFailure = () => {
  return {
    type: PURCHASE_ORDERS_CREATE_FAILURE
  }
};


export const purchaseOrdersUpdateRequested = () => {
  return {
    type: PURCHASE_ORDERS_UPDATE_REQUESTED
  }
};

export const purchaseOrdersUpdateSuccess = (purchaseOrder) => {
  return {
    type: PURCHASE_ORDERS_UPDATE_SUCCESS,
    purchaseOrder: purchaseOrder.updated_purchase_order
  }
};

export const purchaseOrdersUpdateFailure = () => {
  return {
    type: PURCHASE_ORDERS_UPDATE_FAILURE
  }
};


export const purchaseOrdersDeleteRequested = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDERS_DELETE_REQUESTED,
    purchaseOrderId: purchaseOrderId
  }
};

export const purchaseOrdersDeleteSuccess = () => {
  return {
    type: PURCHASE_ORDERS_DELETE_SUCCESS
  }
};

export const purchaseOrdersDeleteFailure = () => {
  return {
    type: PURCHASE_ORDERS_DELETE_FAILURE
  }
};


export const purchaseOrderMarkIssuedRequested = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_ISSUED_REQUESTED,
    purchaseOrderId: purchaseOrderId
  }
};

export const purchaseOrderMarkIssuedSuccess = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_ISSUED_SUCCESS,
    purchaseOrderId: purchaseOrderId
  }
};

export const purchaseOrderMarkIssuedFailure = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_ISSUED_FAILURE,
    purchaseOrderId: purchaseOrderId
  }
};


export const purchaseOrderMarkFulfilledRequested = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_FULFILLED_REQUESTED,
    purchaseOrderId: purchaseOrderId
  }
}

export const purchaseOrderMarkFulfilledSuccess = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_FULFILLED_SUCCESS,
    purchaseOrderId: purchaseOrderId
  }
}

export const purchaseOrderMarkFulfilledFailure = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_FULFILLED_FAILURE,
    purchaseOrderId: purchaseOrderId
  }
}



export const purchaseOrderMarkPaidRequested = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_PAID_REQUESTED,
    purchaseOrderId: purchaseOrderId
  }
};

export const purchaseOrderMarkPaidSuccess = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_PAID_SUCCESS,
    purchaseOrderId: purchaseOrderId
  }
};

export const purchaseOrderMarkPaidFailure = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_PAID_FAILURE,
    purchaseOrderId: purchaseOrderId
  }
};



export const purchaseOrderMarkClosedRequested = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_CLOSED_REQUESTED,
    purchaseOrderId: purchaseOrderId
  }
};

export const purchaseOrderMarkClosedSuccess = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_CLOSED_SUCCESS,
    purchaseOrderId: purchaseOrderId
  }
};

export const purchaseOrderMarkClosedFailure = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_CLOSED_FAILURE,
    purchaseOrderId: purchaseOrderId
  }
};



export const purchaseOrderMarkRejectedRequested = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_REJECTED_REQUESTED,
    purchaseOrderId: purchaseOrderId
  }
};

export const purchaseOrderMarkRejectedSuccess = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_REJECTED_SUCCESS,
    purchaseOrderId: purchaseOrderId
  }
};

export const purchaseOrderMarkRejectedFailure = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_MARK_REJECTED_FAILURE,
    purchaseOrderId: purchaseOrderId
  }
};

export const purchaseOrderDownloadRequested = () => {
  return {
    type: PURCHASE_ORDER_DOWNLOAD_REQUESTED
  }
};

export const purchaseOrderDownloadSuccess = (response) => {
  return {
    type: PURCHASE_ORDER_DOWNLOAD_SUCCESS,
    downloadUrl: response.downloadUrl
  }
};

export const purchaseOrderDownloadFailure = () => {
  return {
    type: PURCHASE_ORDER_DOWNLOAD_FAILURE
  }
};



export const addItem = (itemData) => {
  return {
    type: ADD_TO_PO,
    payload: itemData
  }
}

export const updateExternalItem = (itemData) => {
  return {
    type: UPDATE_EXTERNAL_PO_LINE,
    payload: itemData
  }
}

export const adjustTotal = (total) => {
  return {
    type: ADJUST_TOTAL,
    payload: total
  }
}

export const updateQuantity = (itemData, itemKey) => {
  return {
    type: UPDATE_PO_QUANTITY,
    data: itemData,
    key: itemKey
  }
}

export const overrideUnitCost = (itemData, itemKey) => {
  return {
    type: OVERRIDE_UNIT_COST,
    data: itemData,
    key: itemKey
  }
}

export const overrideUnitTax = (itemData, itemKey) => {
  return {
    type: OVERRIDE_UNIT_TAX,
    data: itemData,
    key: itemKey
  }
}

export const removePurchaseOrderLine = (itemKey) => {
  return {
    type: REMOVE_FROM_PO,
    key: itemKey
  }
}

export const purchaseOrderUpdateShipmentsRequested = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_UPDATE_SHIPMENTS_REQUESTED,
    purchaseOrderId: purchaseOrderId
  }
}

export const purchaseOrderUpdateShipmentsSuccess = (purchaseOrderId, shipments) => {
  return {
    type: PURCHASE_ORDER_UPDATE_SHIPMENTS_SUCCESS,
    purchaseOrderId: purchaseOrderId,
    shipments: shipments
  }
}

export const purchaseOrderUpdateShipmentsFailure = (purchaseOrderId) => {
  return {
    type: PURCHASE_ORDER_UPDATE_SHIPMENTS_FAILURE,
    purchaseOrderId: purchaseOrderId
  }
}


export const purchaseOrderCheckItemExistenceRequested = () => {
  return {
    type: PURCHASE_ORDER_CHECK_ITEM_EXISTENCE_REQUESTED
  }
}

export const purchaseOrderCheckItemExistenceSuccess = (itemResult) => {
  return {
    type: PURCHASE_ORDER_CHECK_ITEM_EXISTENCE_SUCCESS,
    itemResult: itemResult
  }
}

export const purchaseOrderCheckItemExistenceFailure = () => {
  return {
    type: PURCHASE_ORDER_CHECK_ITEM_EXISTENCE_FAILURE
  }
}

export const resetState = () => {
  return {
    type: RESET_PURCHASE_ORDER_STATE,
  }
}

export const resetNewPO = () => {
  return {
    type: RESET_NEW_PO
  }
}

// TODO: make this take a status argument or an open argument to cover non-closed POs
export const purchaseOrdersIndex = (signedPayload, status, continuationToken, page, sortKey, reverseOrder) => {
  return (dispatch) => {
    dispatch(purchaseOrdersIndexRequested());

    let endPoint = Config.baseUrl + Config.purchaseOrders + `?status=${status}`;
    let headers = Object.assign(Config.headers);
    let continuationFilter = 'id';
    headers.payload = signedPayload;

    if (continuationToken) {
      if(sortKey === 'invoice_number') {
        continuationFilter = 'invoice_number'
      }

      if(sortKey === 'supplier_number') {
        continuationFilter = 'supplier_order_number';
      }

      endPoint = endPoint + `&continuationToken=${continuationToken[continuationFilter]}&continuationFilter=${continuationFilter}&continuationId=${continuationToken['id']}`;
    }

    if (sortKey) {
      endPoint = endPoint + `&sortIndex=${sortKey}`;
    }

    if (reverseOrder) {
      endPoint = endPoint + `&reverseOrder=${reverseOrder}`;
    }

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(purchaseOrdersIndexSuccess(response.data, page));
      })
      .catch((error) => {
        dispatch(purchaseOrdersIndexFailure());
      });
  }
}

export const findPurchaseOrder = (signedPayload, purchaseOrderId, status) => {
  return (dispatch) => {
    dispatch(purchaseOrderFindRequested());

    let endPoint = Config.baseUrl + Config.purchaseOrder + purchaseOrderId;

    if(status) {
      endPoint = endPoint + `?status=${status}`
    }

    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(purchaseOrderFindSuccess(response.data));
      })
      .catch((error) => {
        dispatch(purchaseOrderFindFailure());
      });

  }
}

export const purchaseOrdersCreate = (signedPayload, purchaseOrderData, purchaseOrderLineData, purchaseOrderType) => {
  return (dispatch) => {
    dispatch(purchaseOrdersCreateRequested());

    let endPoint = Config.baseUrl + Config.purchaseOrder;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.post(endPoint, { purchaseOrderData: purchaseOrderData, purchaseOrderLineData: purchaseOrderLineData, purchaseOrderType: purchaseOrderType }, { headers: headers })
      .then((response) => {
        dispatch(purchaseOrdersCreateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(purchaseOrdersCreateFailure());
      });
  }
}

export const purchaseOrdersUpdate = (signedPayload, id, purchaseOrderData, purchaseOrderLineData) => {
  return (dispatch) => {
    dispatch(purchaseOrdersUpdateRequested());

    let endPoint = Config.baseUrl + Config.purchaseOrder;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    // TODO: switch this to fill in an "updateValues" value, give it a purchaseOrderId to make it match with the other updates

    let body = { 
      purchaseOrderId: id,
      purchaseOrderData: purchaseOrderData,
      purchaseOrderLineData: purchaseOrderLineData
    }

    return Axios.put(endPoint, body, { headers: headers })
      .then((response) => {
        dispatch(purchaseOrdersUpdateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(purchaseOrdersUpdateFailure());
      });
  }
}

export const purchaseOrdersDelete = (signedPayload, purchaseOrderId) => {
  return (dispatch) => {
    dispatch(purchaseOrdersDeleteRequested());

    let endPoint = Config.baseUrl + Config.purchaseOrder + purchaseOrderId;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch(purchaseOrdersDeleteSuccess(response.data));
      })
      .catch((error) => {
        dispatch(purchaseOrdersDeleteFailure());
      });
  }
}

export const markPOIssued = (signedPayload, purchaseOrderId) => {
  return (dispatch) => {
    dispatch(purchaseOrderMarkIssuedRequested(purchaseOrderId));

    let endPoint = Config.baseUrl + Config.purchaseOrder;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    let body = {
      purchaseOrderId: purchaseOrderId,
      updateValues: {
        status: 'issued'
      }
    }

    return Axios.put(endPoint, body, { headers: headers })
      .then((response) => {
        dispatch(purchaseOrderMarkIssuedSuccess(purchaseOrderId));
      })
      .catch((error) => {
        dispatch(purchaseOrderMarkIssuedFailure(purchaseOrderId));
      });
  }
}

export const markPOPaid = (signedPayload, purchaseOrderId) => {
  return (dispatch) => {
    dispatch(purchaseOrderMarkPaidRequested(purchaseOrderId));

    let endPoint = Config.baseUrl + Config.purchaseOrder;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    let body = {
      purchaseOrderId: purchaseOrderId,
      updateValues: {
        payment_status: 'paid'
      }
    }

    return Axios.put(endPoint, body, { headers: headers })
      .then((response) => {
        dispatch(purchaseOrderMarkPaidSuccess(purchaseOrderId));
      })
      .catch((error) => {
        dispatch(purchaseOrderMarkPaidFailure(purchaseOrderId));
      });
  }
}

export const markPOClosed = (signedPayload, purchaseOrderId) => {
  return (dispatch) => {
    dispatch(purchaseOrderMarkClosedRequested(purchaseOrderId));

    let endPoint = Config.baseUrl + Config.purchaseOrder;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    let body = {
      purchaseOrderId: purchaseOrderId,
      updateValues: {
        archived: 'true'
      }
    }

    return Axios.put(endPoint, body, { headers: headers })
      .then((response) => {
        dispatch(purchaseOrderMarkClosedSuccess(purchaseOrderId));
      })
      .catch((error) => {
        dispatch(purchaseOrderMarkClosedFailure(purchaseOrderId));
      });
  }
}


export const markPORejected = (signedPayload, purchaseOrderId) => {
  return (dispatch) => {
    dispatch(purchaseOrderMarkRejectedRequested(purchaseOrderId));

    let endPoint = Config.baseUrl + Config.purchaseOrder;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    let body = {
      purchaseOrderId: purchaseOrderId,
      updateValues: {
        rejected: 'true'
      }
    }

    return Axios.put(endPoint, body, { headers: headers })
      .then((response) => {
        dispatch(purchaseOrderMarkRejectedSuccess(purchaseOrderId));
      })
      .catch((error) => {
        dispatch(purchaseOrderMarkRejectedFailure(purchaseOrderId));
      });
  }
}

export const markPOFulfilled = (signedPayload, purchaseOrderId) => {
  return (dispatch) => {
    dispatch(purchaseOrderMarkFulfilledRequested(purchaseOrderId));

    let endPoint = Config.baseUrl + Config.purchaseOrder;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    let body = {
      purchaseOrderId: purchaseOrderId,
      updateValues: {
        status: 'fulfilled'
      }
    }

    return Axios.put(endPoint, body, { headers: headers })
      .then((response) => {
        dispatch(purchaseOrderMarkFulfilledSuccess(purchaseOrderId));
      })
      .catch((error) => {
        dispatch(purchaseOrderMarkFulfilledFailure(purchaseOrderId));
      });
  }
}

export const updateShipments = (signedPayload, purchaseOrderId, shipments) => {
  return (dispatch) => {
    dispatch(purchaseOrderUpdateShipmentsRequested(purchaseOrderId));

    let endPoint = Config.baseUrl + Config.purchaseOrder;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    let body = {
      purchaseOrderId: purchaseOrderId,
      updateValues: {
        shipments: shipments
      }
    }

    return Axios.put(endPoint, body, { headers: headers })
      .then((response) => {
        dispatch(purchaseOrderUpdateShipmentsSuccess(purchaseOrderId, shipments));
      })
      .catch((error) => {
        dispatch(purchaseOrderUpdateShipmentsFailure(purchaseOrderId));
      });
  }
}

export const downloadOrderPdf = (signedPayload, status, purchaseOrderId, options) => {
  return (dispatch) => {
    dispatch(purchaseOrderDownloadRequested());

    let endPoint = Config.baseUrl + Config.purchaseOrder + Config.download + purchaseOrderId + `?status=${status}`;

    Object.keys(options).forEach((option) => {
      endPoint = endPoint + `&${option}=${options[option].toString()}`
    });

    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(purchaseOrderDownloadSuccess(response.data));
      })
      .catch((error) => {
        dispatch(purchaseOrderDownloadFailure());
      });

  } 
}

export const itemExistence = (signedPayload, itemId, productId, variantId) => {
  return (dispatch) => {
    dispatch(purchaseOrderCheckItemExistenceRequested());

    let endPoint = Config.baseUrl + Config.purchaseOrder + Config.item + itemId + '/' + productId;

    if(variantId) {
      endPoint = endPoint + '/' + variantId
    }

    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(purchaseOrderCheckItemExistenceSuccess(response.data));
      })
      .catch((error) => {
        dispatch(purchaseOrderCheckItemExistenceFailure());
      });
  }
}


export const purchaseOrderAddItem = (signedPayload, itemData) => {
  return (dispatch) => {
    dispatch(addItem(itemData));
  }
}

export const purchaseOrderUpdateExternalItem = (signedPayload, itemData) => {
  return (dispatch) => {
    dispatch(updateExternalItem(itemData));
  }
}

// export const purchaseOrderAdjustTotal = (signedPayload, total) => {
//   return (dispatch) => {
//     dispatch(adjustTotal(total));
//   }
// }

export const purchaseOrderUpdateQuantity = (signedPayload, itemData, itemKey) => {
  return (dispatch) => {
    dispatch(updateQuantity(itemData, itemKey));
  }
}

export const purchaseOrderOverrideUnitCost = (signedPayload, itemData, itemKey) => {
  return (dispatch) => {
    dispatch(overrideUnitCost(itemData, itemKey));
  }
}

export const purchaseOrderOverrideLineTax = (signedPayload, itemData, itemKey) => {
  return (dispatch) => {
    dispatch(overrideUnitTax(itemData, itemKey));
  }
}

export const removeOrderLine = (itemKey) => {
  return (dispatch) => {
    dispatch(removePurchaseOrderLine(itemKey));
  }
}

export const resetNewPurchaseOrder = () => {
  return (dispatch)  =>{
    dispatch(resetNewPO());
  }
}

export const reset = () => {
  return (dispatch)  =>{
    dispatch(resetState());
  }
}
